import React, { useEffect , useState } from "react";
import styled, { css } from "styled-components";
import { RootState } from "../store";
import { useShallowEqualSelector } from "../modules/hooks"
import { useDispatch, useSelector } from "react-redux";

//region style
const Subtitle = styled.p`
    text-align: center;
    font-weight: bold;
    color: #064645;

    ${(props) => {

      if (props.theme.isMobile || props.theme.isTablet) {
        return css`
          margin-top:45px;
          margin-bottom: 16px;
          font-size: 40px;
          `;
      }
      else {
        return css`
        margin-top: 150px;
        margin-bottom: 45px;
        font-size: 50px;
          `;
      }
    }}

`;

const Layer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 5px 0;
`;

const LayerColumn = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin: 5px 0;
`;


const Part6BackGround = styled.div`
  width: 100%;
  border-radius: 30px;
  background: #cae7e2;

  ${(props) => {

    if (props.theme.isMobile || props.theme.isTablet) {
      return css`
        `;
    }
    else {
      return css`
      height: 880px;
      margin-bottom: 30px;
        `;
    }
  }}

`;

const Part6Div = styled.div`
  font-size: 31px;
  color: rgb(45,119,106);

  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  ${(props) => {

    if (props.theme.isMobile || props.theme.isTablet) {
      return css`
      padding: 12% 5% 0 5%;
        `;
    }
    else {
      return css`
      padding: 70px 75px 60px 75px;
        `;
    }
  }}

`;

const Part6Top1Number = styled.div`
  font-size: 60px;
  color: rgb(27,150,157);
  font-weight: bold;
  letter-spacing: 3px;
  padding-left: 23px;
  padding-right: 18px;
  transform: scale(1.15,1);
  display: inline-block;
  `;

const Part6Top1Name = styled.div`
  font-size: 57px;
  color: rgb(27,150,157);
  font-weight: bold;


  ${(props) => {

    if (props.theme.isMobile || props.theme.isTablet) {
      return css`
      margin-top: 30px;
      margin-bottom: 12px;
        `;
    }
    else {
      return css`
      margin-top: 38px;
      margin-bottom: 24px;
        `;
    }
  }}
  `;

const Part6GreenBar = styled.div`
  height: 82px;
  border-radius: 41px;
  color: white;Part6_G1990
  font-weight: bold;
  background-color: rgb(16,107,102);
  display: flex;
  justify-content: center;
  align-items: center;

  ${(props) => {

    if (props.theme.isMobile || props.theme.isTablet) {
      return css`
      margin-top:20px;
      font-size: 32px;
      text-align: center;
      padding:0 30px;
        `;
    }
    else {
      return css`
      margin-top:55px;
      margin-bottom:35px;
      font-size: 38px;
      padding:0 40px;
        `;
    }
  }}

  `;

const Part6Separate = styled.div`
  background-image: url("${process.env.PUBLIC_URL}/images/06-separate.png");
  width: 4px;
  height: 25px;
  background-size: cover;
  ${(props) => {

    if (props.theme.isMobile || props.theme.isTablet) {
      return css`
      margin-top: 12px;
        `;
    }
    else {
      return css`
      margin-top: 22px;
        `;
    }
  }}
  `;

const Part6G1990 = styled.div`

  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  ${(props) => {

    if (props.theme.isMobile || props.theme.isTablet) {
      return css`
      padding-top: 20px;
      padding-bottom: 20px;
        `;
    }
    else {
      return css`
      padding-top: 25px;
      margin-right: 50px;
        `;
    }
  }}

  `;
  
const Part6G2000 = styled.div`
  
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  
  ${(props) => {

    if (props.theme.isMobile || props.theme.isTablet) {
      return css`
      border-top: 2px dashed rgb(135,180,177);
      border-bottom: 2px dashed rgb(135,180,177);
      padding-top: 20px;
      padding-bottom: 20px;
        `;
    }
    else {
      return css`
      padding: 25px 50px 8px 50px;
      border-left: 2px dashed rgb(135,180,177);
      border-right: 2px dashed rgb(135,180,177);
        `;
    }
  }}
  
  `;

const Part6G2010 = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  ${(props) => {

    if (props.theme.isMobile || props.theme.isTablet) {
      return css`
      padding-top: 20px;
      padding-bottom: 20px;
        `;
    }
    else {
      return css`
      padding-top: 25px;
      margin-left: 50px;
        `;
    }
  }}

  `;

const Part6Year = styled.div`
  font-weight: bold;
  letter-spacing: 1px;

  ${(props) => {

    if (props.theme.isMobile || props.theme.isTablet) {
      return css`
      margin-bottom: 20px;
        `;
    }
    else {
      return css`
      margin-bottom: 40px;
        `;
    }
  }}

  `;

const Part6Name = styled.div`
  padding-left: 26px;
  `;

const Part6Nunmber = styled.div`
  letter-spacing: 1px;
  width: 115px;
  text-align: right;

  span{
    font-size: 20px;
  }

  `;

const Part6RankYellow = styled.div`
  height: 25px;
  width: 25px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  color: black;
  background-color: rgb(253,200,0);
  `;

  const Part6RankGray = styled.div`
  height: 25px;
  width: 25px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  color: black;
  background-color: rgb(197,199,198);
  `;
//endregion

function Part6(_props: any) {
  const isMobile: any = useSelector((state: RootState) => state.storeSlice.isMobile);
  const isTablet: any = useSelector((state: RootState) => state.storeSlice.isTablet);
  const generalInfo: any = useShallowEqualSelector((state: RootState) => state.storeSlice.generalInfo);
  const [top5Gen90Name_Names, setTop5Gen90Name_Names] = useState([]);
  const [top5Gen90Name_Counts, setTop5Gen90Name_Counts] = useState(new Array(10).fill(0));
  const [top5Gen00Name_Names, setTop5Gen00Name_Names] = useState([]);
  const [top5Gen00Name_Counts, setTop5Gen00Name_Counts] = useState(new Array(10).fill(0));
  const [top5Gen10Name_Names, setTop5Gen10Name_Names] = useState([]);
  const [top5Gen10Name_Counts, setTop5Gen10Name_Counts] = useState(new Array(10).fill(0));


  function formatNumber(Number: any) {
    return String(Number).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

function Part6TableSignleLayer(Rank:any , Name: any , Number: any ) {

  let result=[];
  if(Rank<3){
    result.push(
      <Layer key={Rank}>
        <Part6RankYellow>{Rank}</Part6RankYellow>
        <Part6Name>{Name}</Part6Name>
        <Part6Nunmber>{formatNumber(Number)}<span>人</span></Part6Nunmber>
      </Layer>
    );
  }
  else{
    result.push(
      <Layer key={Rank}>
        <Part6RankGray>{Rank}</Part6RankGray>
        <Part6Name>{Name}</Part6Name>
        <Part6Nunmber>{formatNumber(Number)}<span>人</span></Part6Nunmber>
      </Layer>
    );
  }

  return result;

}

const Part6Table = () =>{

  let Gen90 = [];
  let Gen00 = [];
  let Gen10 = [];

  for (let i = 0; i < 5; i++) {
    Gen90.push(
      Part6TableSignleLayer(i+1,top5Gen90Name_Names[i],top5Gen90Name_Counts[i])
    );
    Gen00.push(
      Part6TableSignleLayer(i+1,top5Gen00Name_Names[i],top5Gen00Name_Counts[i])
    );
    Gen10.push(
      Part6TableSignleLayer(i+1,top5Gen10Name_Names[i],top5Gen10Name_Counts[i])
    );
  }

  if (isMobile || isTablet) {
    return (
      <LayerColumn>
        <Part6G1990>
          <Part6Year>1990 – 1999</Part6Year>
          {Gen90}
        </Part6G1990>
        <Part6G2000>
          <Part6Year>2000 – 2009</Part6Year>
          {Gen00}
        </Part6G2000>
        <Part6G2010>
          <Part6Year>2010 – 2019</Part6Year>
          {Gen10}
        </Part6G2010>
      </LayerColumn>
    )
  }
  else{
    return (
      <Layer>
        <Part6G1990>
          <Part6Year>1990 – 1999</Part6Year>
          {Gen90}
        </Part6G1990>
        <Part6G2000>
          <Part6Year>2000 – 2009</Part6Year>
          {Gen00}
        </Part6G2000>
        <Part6G2010>
          <Part6Year>2010 – 2019</Part6Year>
          {Gen10}
        </Part6G2010>
      </Layer>
    )
  }
}

  useEffect(() => {
    if (generalInfo) {
      setTop5Gen90Name_Names(generalInfo.top5Gen90Name.map((m: any) => m.name));
      setTop5Gen90Name_Counts(generalInfo.top5Gen90Name.map((m: any) => m.count));
      setTop5Gen00Name_Names(generalInfo.top5Gen00Name.map((m: any) => m.name));
      setTop5Gen00Name_Counts(generalInfo.top5Gen00Name.map((m: any) => m.count));
      setTop5Gen10Name_Names(generalInfo.top5Gen10Name.map((m: any) => m.name));
      setTop5Gen10Name_Counts(generalInfo.top5Gen10Name.map((m: any) => m.count));
    }
  }, [generalInfo]);


  if (isMobile || isTablet) {
    return (
      <>
        <Subtitle>不同年代<br/>最常用的名字</Subtitle>
        <Part6BackGround>
          <Part6Div>
            <div>10後最常用的名字是...</div>
            <Part6Top1Name>{top5Gen10Name_Names[0]}</Part6Top1Name>
            <div>共有<Part6Top1Number>{formatNumber(top5Gen10Name_Counts[0])}</Part6Top1Number>人</div>
            <Part6Separate/>
            <Part6GreenBar>你的年代<br/>最常用的名字是...</Part6GreenBar>
            <Part6Table/>
          </Part6Div>
        </Part6BackGround>
      </>
    )
  }
  else{
    return (
      <>
        <Subtitle>不同年代最常用的名字</Subtitle>
        <Part6BackGround>
          <Part6Div>
            <div>10後最常用的名字是...</div>
            <Part6Top1Name>{top5Gen10Name_Names[0]}</Part6Top1Name>
            <div>共有<Part6Top1Number>{formatNumber(top5Gen10Name_Counts[0])}</Part6Top1Number>人</div>
            <Part6Separate/>
            <Part6GreenBar>你的年代最常用的名字是...</Part6GreenBar>
            <Part6Table/>
          </Part6Div>
        </Part6BackGround>
      </>
    )
  }
}

export default Part6;
